import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/eeucalogo2.png';

const Header = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <Navbar bg="light" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src={logo}
            height="50"
            className="d-inline-block align-top"
            alt="EUCA Church"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/"
              style={{ fontWeight: isActive('/') ? 'bold' : 'normal' }}
            >
              {t('home')}
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/about"
              style={{ fontWeight: isActive('/about') ? 'bold' : 'normal' }}
            >
              {t('about_us')}
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/causes"
              style={{ fontWeight: isActive('/causes') ? 'bold' : 'normal' }}
            >
              {t('causes')}
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              style={{ fontWeight: isActive('/contact') ? 'bold' : 'normal' }}
            >
              {t('contact_us')}
            </Nav.Link>
            <NavDropdown
              title={<span>🌐</span>}
              id="language-dropdown"
              align="end"
            >
              <NavDropdown.Item
                onClick={() => changeLanguage('en')}
                style={{ fontWeight: i18n.language === 'en' ? 'bold' : 'normal' }}
              >
                English
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => changeLanguage('fr')}
                style={{ fontWeight: i18n.language === 'fr' ? 'bold' : 'normal' }}
              >
                Français
              </NavDropdown.Item>
              <NavDropdown.Item
                onClick={() => changeLanguage('hk')}
                style={{ fontWeight: i18n.language === 'hk' ? 'bold' : 'normal' }}
              >
                Kreyòl
              </NavDropdown.Item>
            </NavDropdown>
              <Link
                  to="/donate"
                  className="btn btn-primary text-white ms-2 align-self-center"
                  style={{
                      fontWeight: isActive('/donate') ? 'bold' : 'normal',
                      textDecoration: 'none'
                  }}
              >
                  {t('donate')}
              </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
